// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__N9st8","title":"AfterFrontImage_title__1h1UY"};